import { Avatar } from "@mui/material";

function Header(props) {
    return <Avatar src='/images/png/riki_logo_15.png' variant="square" {...props}/>;
}

export default Header;